import { Link, Outlet, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaHouse, FaCommentDots, FaRightFromBracket } from "react-icons/fa6";
import { routes } from "../routes/routes";
import {
  ConversationsProvider,
  useConversationsContext,
} from "../context/ConversationsListContext";
import { ConversationsMenu } from "../components/ConversationsMenu";

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [showConversations, setShowConversations] = useState(false);
  const [section, setSection] = useState("chat");
  const navigate = useNavigate();
  const { conversations, loadUserConversations } = useConversationsContext();
  const sidebarRef = useRef(null);

  const handleCollapse = () => {
    if (collapsed) {
      setShowConversations(false);
    }
    setCollapsed(!collapsed);
  };

  const handleChat = () => {
    setShowConversations(!showConversations);
    setCollapsed(true);
    setSection("chat");
  };

  const clickConversation = (conversation) => {
    const url = `${routes.chat.path}/${conversation.uuid}`;
    navigate(url);
    setShowConversations(false);
  };

  const newChat = () => {
    navigate(routes.chat.path);
    setShowConversations(false);
  };

  useEffect(() => {
    loadUserConversations();
  }, []);

  // Fermer si clic en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      const modalIsOpen = document.querySelector(".modal-backdrop.show");

      // Si une modale est ouverte, ne rien faire
      if (modalIsOpen) return;

      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setShowConversations(false);
      }
    };

    if (showConversations) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showConversations]);

  return (
    <div>
      <div className="d-flex vh-100">
        <div className="d-none d-lg-block">
          <div
            className={`sidebar d-flex vh-100 flex-column py-3 ps-3 pe-0 text-primary position-relative shadow overflow-y-auto ${
              collapsed ? "collapsed" : ""
            }`}
            style={{ width: "250px" }}
          >
            {/* <button
              className="btn btn-sm btn-outline-primary mb-3"
              onClick={() => setCollapsed(!collapsed)}
            >
              {collapsed ? "☰" : "←"}
            </button> */}

            <div
              className="px-0 py-2 m-0 d-flex align-items-center"
              onClick={() => handleCollapse()}
            >
              <img
                src="/logos/logo_vivanoda_ai_id.svg"
                height="35px"
                alt="image"
                class="d-flex me-1"
              />

              {collapsed ? (
                ""
              ) : (
                <div>
                  <img
                    src="/logos/logo_vivanoda_ai_name.svg"
                    alt="Logo Vivanoda"
                    class="d-flex"
                    width="150"
                  ></img>
                  <div className="text-info float-end beta-version">bêta</div>
                </div>
              )}
            </div>

            <ul className="nav flex-column">
              {/* <li className="nav-item">
                <Link
                  className={`nav-link text-primary d-flex align-items-center px-0 ${section=="home" ? 'border-5 border-end border-secondary' : ''}`}
                  to={routes.home.path}
                  onClick={() => {
                    setSection('home');
                  }}
                >
                  <FaHouse className="me-2" size={24}/>
                  {collapsed ? "" : "Home"}
                </Link>
              </li> */}
              <li className="nav-item">
                <Link
                  className={`nav-link text-primary d-flex align-items-center px-0 ${
                    section == "chat"
                      ? "border-5 border-end border-secondary"
                      : ""
                  }`}
                  onClick={() => handleChat()}
                >
                  <FaCommentDots className="me-2" size={24} />
                  {collapsed ? (
                    ""
                  ) : (
                    <div className="w-100">
                      <span>Chat</span>
                      <div className="badge bg-info float-end me-3">
                        {conversations.length}
                      </div>
                    </div>
                  )}
                </Link>
              </li>
            </ul>

            {!collapsed && (
              <div className="nav flex-column mt-5 pe-3">
                <div
                  onClick={() => {
                    navigate(routes.chat.path);
                  }}
                  className="btn btn-secondary"
                >
                  New Chat
                </div>
              </div>
            )}

            <div className="d-flex align-items-center position-absolute bottom-0">
              <div className="">
                {collapsed ? (
                  <div className=" flex-column nav">
                    <img
                      src="/logos/logo_vivanoda_ai.svg"
                      alt="Logo Vivanoda"
                      class="collapsed-logo"
                      width="120"
                    ></img>
                  </div>
                ) : (
                  ""
                )}

                <ul className="mt-3 nav flex-column">
                  <li className="nav-item">
                    <Link
                      className="nav-link text-primary d-flex align-items-center px-0"
                      to={routes.logout.path}
                    >
                      <FaRightFromBracket className="me-2" size={24} />
                      {collapsed ? "" : "Logout"}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {showConversations && (
          <div
            className={`secondary-sidebar overflow-y-auto shadow border-secondary border-start  rounded-end p-3 bg-white ${
              showConversations ? "show" : ""
            }`}
            style={{ width: "300px" }}
            ref={sidebarRef}
          >
            <ConversationsMenu
              clickConversation={clickConversation}
              newChat={newChat}
            />
          </div>
        )}

        {/* Contenu principal */}
        <main className="main-content flex-grow-1 position-relative">
          <Outlet /> {/* Contenu des pages */}
        </main>

        {/* Sidebar */}
      </div>
    </div>
  );
}
